import { apiClient } from "./client";
import { setAuthToken } from "../auth/authStorage";

export async function login(credentials, options) {
  const response = await apiClient.post("/auth/login", credentials, { skipAuth: true });
  setAuthToken(response.data.token, options);
  return response.data;
}

export const validateSession = () => apiClient.post("/auth/validate-token");

export async function requestPasswordReset(email) {
  return (await apiClient.post("/auth/forgot-password", { email }, { skipAuth: true })).data;
}

export async function resetPassword({ token, password }) {
  return (await apiClient.post("/auth/reset-password", { token, password }, { skipAuth: true })).data;
}
